import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { PortableAssetPropertiesValues } from '../../util/enums';
import { VOID } from '../../util/typeUtils';
import { portableAssetPropertyLabel } from '../Map/LiveAndReplay/Sidebar/Beacon/helpers';
import { Property } from '../ProjectConfig/types';
import { DisplayProperty } from './types';
import { PRODUCTION_CAPACITY_PROPERTY_KEYS } from '../Assets/helpers';

export const SelectProperty = ({
  property,
  allProperties,
  isFromTable,
  displayGeomobyProperties,
  onKeyPress,
  onChangeProperty,
}: {
  property: DisplayProperty;
  allProperties: Property[];
  isFromTable?: boolean;
  displayGeomobyProperties: {
    index: number;
    property: string;
    value: string;
    deviceIds?: string[];
  }[];
  onKeyPress: (event: { key: string }) => void;
  onChangeProperty: (property: string, prop: DisplayProperty) => Promise<void>;
}) => {
  const existingProperty = allProperties.find(p => p.label === property.property);
  const isInvalidProperty = !existingProperty && !!property.property;
  const disableProperty = property.property === 'emissions_rate';

  return (
    <FormControl
      key={`${property.index}-form`}
      sx={{
        width: '100%',
        marginBottom: '10px',
      }}
    >
      {isInvalidProperty ? (
        <TextField
          id={`${property.index}-invalid-propety-cell`}
          key={`${property.index}-invalid-propety-cell`}
          name={`${property.index}-invalid-propety-cell`}
          label={isFromTable ? '' : 'Property'}
          value={property.property}
          sx={{
            '& .MuiTextField-root': {
              height: '60px',
            },
          }}
          disabled={disableProperty}
          onChange={() => VOID}
          onKeyDown={event => onKeyPress(event)}
          InputLabelProps={{ shrink: true }}
          error={true}
          helperText={
            isFromTable ? '' : 'INVALID. Either delete here or create in Project Configuration.'
          }
        />
      ) : (
        <>
          <InputLabel id={`select-property-${property.index}`}>
            {isFromTable ? '' : 'Property'}
          </InputLabel>
          <Select
            fullWidth
            key={`${property.index}-list-value-cell`}
            inputProps={{ 'data-testid': `select-property-${property.index}` }}
            id={'prop-property-' + property.index}
            name={'prop' + property.index}
            label={isFromTable ? '' : 'Property'}
            value={property.property}
            sx={{
              '& .MuiTextField-root': {
                height: '60px',
              },
            }}
            disabled={disableProperty}
            onChange={async (e: { target: { value: string } }) => {
              property.value = '';
              onChangeProperty(e.target.value, property);
            }}
          >
            {allProperties
              .filter(
                p =>
                  !displayGeomobyProperties.find(
                    d => d.property === p.label && d.property !== property.property,
                  ),
              )
              .filter(p => p.label !== 'emissions_unit') // Filter out unit properties.
              .filter(p => !PRODUCTION_CAPACITY_PROPERTY_KEYS.has(p.label)) // Capacity has a dedicated field.
              .map(propName => (
                <MenuItem
                  key={propName.id ?? propName.label}
                  value={propName.label}
                  disabled={!allProperties.find(p => p.label === propName.label)}
                >
                  <Tooltip title={propName.label}>
                    <Typography
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: 'calc(100% - 50px)',
                      }}
                    >
                      {propName.label === PortableAssetPropertiesValues.emissionsRate
                        ? portableAssetPropertyLabel[PortableAssetPropertiesValues.emissionsRate]
                        : propName.label}
                    </Typography>
                  </Tooltip>
                </MenuItem>
              ))}
          </Select>
        </>
      )}
    </FormControl>
  );
};
